/*
 * @Description: 全局路由导航
 * @Date: 2020-07-15 15:50:34
 * @LastEditTime: 2021-01-06 18:27:27
 */
import router from './router'
import store from './store'
import {
    Message
} from 'element-ui'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import {
    getToken
} from '@/utils/auth'


const whiteList = ['/login']
const needProjectIdList = ['/projectManager/report', '/projectManager/liucun', '/projectManager/huoke']

router.beforeEach(async (to, from, next) => {
    NProgress.start()
    const hasToken = getToken()

    // has token
    if (hasToken) {
        if (to.path === '/login') {
            next({
                path: '/'
            })
            NProgress.done()
        } else {
            console.log('has token --->', to.path);
            const hasGetUserInfo = store.getters.name
            // if (store.state.permission.routes.length === 0) {
            //     // 获取动态路由
            //     const accessRoutes = await store.dispatch('permission/generateRoutes')
            //     accessRoutes.push({
            //         path: '*',
            //         redirect: '/404',
            //         hidden: true
            //     });
            //     // 添加路由
            //     router.addRoutes(accessRoutes)
            //     next({
            //         ...to,
            //         replace: true
            //     })
            // }
            // TODO : userInfo
            if (needProjectIdList.indexOf(to.path) !== -1) {
                if (!localStorage.getItem('curApp')) {
                    Message.error('请选择App')
                }
            }

            if (hasGetUserInfo) {
                next()
            } else {
                try {
                    next()
                } catch (error) {
                    // 删除token 跳转登陆页
                    Message.error(error)
                    next(`/login?redirect=${to.path}`)
                    NProgress.done()
                }
            }

        }
    } else { // no token 
        console.log('login to path --->',to.path);
        if (whiteList.indexOf(to.path) !== -1) {
            next()
        } else {
            next(`/login?redirect=${to.path}`)
            NProgress.done()
        }
    }
})

router.afterEach(() => {
    NProgress.done()
})